<div class="flex flex-col gap-medpace">
    @let modalContent = this.modalContent();
    <medpace-labeled-text [label]="'Current Status'" [text]="currentStatus() ?? ''" />

    <div class="flex flex-col gap-medpace">
        <mds-dropdown
            [closeOnPageScroll]="false"
            [formCtrl]="formGroup().controls.newStatusId"
            [appearance]="'outline'"
            [label]="'Change Status to'"
            [placeholder]="'Please Select Status'"
            [options]="options() ?? []"
            [id]="'statusDropdown'"
            [required]="true"
        ></mds-dropdown>
    </div>

    <mds-textarea
        [label]="'Additional Information'"
        [placeholder]="'Type here...'"
        [appearance]="'outline'"
        [id]="'additionalInfo'"
        [autoSize]="true"
        [cdkAutosizeMinRows]="8"
        [cdkAutosizeMaxRows]="8"
        [formCtrl]="formGroup().controls.additionalInfo"
    />

    <div class="flex flex-row gap-medpace justify-end">
        @let cancelButton = modalContent.cancelButton;
        <mds-button id="cancel-btn" label="Cancel" (clickEvent)="cancelButton.onClick()" variant="outline"></mds-button>
        @let confirmButton = modalContent.confirmButton;
        <mds-button
            id="confirm-btn"
            label="Confirm"
            (clickEvent)="confirmButton.onClick()"
            [variant]="'filled'"
            [color]="'primary'"
        ></mds-button>
    </div>
</div>
